import React, { useEffect, useState } from "react";
import { IInvoice } from "../../interfaces/IInvoice";
import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from "@mui/material";
import { IInvoiceServicePosition } from "../../interfaces/IInvoiceServicePosition";
import { getTmpId } from "../core/generic_helpders";
import { InvoiceCreditingRow } from "./InvoiceCreditingRow";

interface IProps {
    invoice: IInvoice;
    setInvoice: Function;
    isOpenNew: boolean;
    setIsOpenNew: Function;
} 

export const InvoiceCreditingTable:React.FC<IProps> = ({
    invoice,
    setInvoice,
    isOpenNew,
    setIsOpenNew
}) => {
    const getEmtyCreditingPosition = (localArra:IInvoiceServicePosition[]) : IInvoiceServicePosition => {
        const tmpId = getTmpId(localArra);
        return {
            articelNumber: "1",
            description: "",
            id:tmpId,
            Invoice: invoice.id,
            InvoiceServicePositionType: 50,
            Partner: null,
            position: 1,
            price: 0,
            price_per_hour: 0,
            Service: null,
            timeFactor: 0,
            title: "Gutschrift",
            Unit: 6,
            units: 1,
            wasChangedPrice: false,
            wasChangedPricePerHour: false,
            wasChangedTimeFactor: false,
            wasChangedTitle: false
        }
    }

    const [invServicePositions, setInvServicePositions] = useState(invoice.InvoiceServicePositions.length === 0 
        ? [getEmtyCreditingPosition([])]
        : invoice.InvoiceServicePositions
    );

    const total = invServicePositions.map(invPos => invPos.price).reduce((a,b) => a+b,0)

    useEffect(() => {
        if (isOpenNew) {
            setInvServicePositions([
                ...invServicePositions,
                getEmtyCreditingPosition(invServicePositions)
            ])
            setIsOpenNew(false)
        }
    },[isOpenNew])


    useEffect(() => {
        setInvoice({
            ...invoice,
            InvoiceServicePositions: invServicePositions
        })
    },[invServicePositions])



    return(
        <>
            <Typography variant="h5">Positionen</Typography>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>Begründung/Titel</TableCell>
                        <TableCell width={250}>Gutschrift</TableCell>
                        <TableCell width={90}>Aktionen</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {invServicePositions.map(invPos =>
                        <InvoiceCreditingRow
                            key={`pos-credit-pos-${invPos.id}`}
                            invCreditPos={invPos}
                            invCreditPositions={invServicePositions}
                            setInvCreditPositions={setInvServicePositions}
                        />
                    )}

                    <TableRow sx={{ borderBottom: "solid 1px" }}>
                        <TableCell />
                        <TableCell sx={{ borderBottom: "solid 1px" }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                <Typography sx={{fontWeight: "bold"}}>Summe</Typography>
                                <Typography>
                                {(total).toLocaleString("de-DE", { style: "currency", currency: "EUR" })}
                                </Typography>
                            </Box>
                        </TableCell>
                        <TableCell/>
                    </TableRow>
                    <TableRow sx={{ borderBottom: "solid 1px" }}>
                        <TableCell />
                        <TableCell sx={{ borderBottom: "solid 1px" }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                <Typography sx={{fontWeight: "bold"}}>MwSt</Typography>
                                <Typography>
                                {(total * invoice.vat).toLocaleString("de-DE", { style: "currency", currency: "EUR" })}
                                </Typography>
                            </Box>
                        </TableCell>
                        <TableCell/>
                    </TableRow>
                    <TableRow sx={{ borderBottom: "solid 1px" }}>
                        <TableCell />
                        <TableCell sx={{ borderBottom: "solid 1px" }}>
                            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                                <Typography sx={{fontWeight: "bold"}}>Total</Typography>
                                <Typography>
                                {(total * (1+invoice.vat)).toLocaleString("de-DE", { style: "currency", currency: "EUR" })}
                                </Typography>
                            </Box>
                        </TableCell>
                        <TableCell/>
                    </TableRow>
                </TableBody>
            </Table>

        </>
    )
}